import { Colors, Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { useMediaQuery } from "react-responsive";

import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { Box } from "@/components/layout/flexbox";
import { isXsQuery } from "@/components/layout/Media";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { BRAND_PURPLE } from "@/css/constants";

interface BackButtonProps {
  onClick: () => void;
  hoverMessage?: string | null;
  mediaQuery: { query: string };
  mt?: number[];
}

export function BackButton({
  onClick,
  hoverMessage = null,
  mediaQuery,
  mt = [12],
}: BackButtonProps) {
  const isXs = useMediaQuery(isXsQuery);
  const isMatchedCustomMediaQuery = useMediaQuery(mediaQuery);
  let Container = AbsoluteStyledContainer;
  if (isMatchedCustomMediaQuery) {
    Container = StyledContainer;
  }
  return (
    <Container ml={[0, 0, 3]} mt={mt}>
      <Tooltip content={hoverMessage} disabled={!hoverMessage} usePortal={true}>
        <Clickable onClick={onClick}>
          <Box p={3} pl={[0, 3]}>
            <Icon className="icon" icon="arrow-left" size={isXs ? 24 : 30} />
          </Box>
        </Clickable>
      </Tooltip>
    </Container>
  );
}

const StyledContainer = styled(Box)`
  top: 0;
  left: 0;
  z-index: 1;
  .icon {
    color: ${Colors.GRAY3};
  }
  :hover {
    .icon {
      color: ${BRAND_PURPLE};
    }
  }
`;

const AbsoluteStyledContainer = styled(StyledContainer)`
  position: absolute;
`;
